$( document ).ready(function() {
     $('.variant-option label').on('click', function () {
           var type = $(this).closest(".variant-option").find('input').val();
           var oldURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
           var newUrl = oldURL + "?variant=" + type;
           if (window.history != 'undefined' && window.history.pushState != 'undefined') {
              window.history.pushState({ path: newUrl }, '', newUrl);
           }
    });
 });            